import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
})
export class TruncatePipe implements PipeTransform {
  transform(text: string, maxLength: number | undefined = undefined, wordBreakThreshold: number = 0.8): string {
    if (!text || !maxLength || text.length <= maxLength) {
      return text;
    }

    const truncated = text.substring(0, maxLength);
    const lastSpaceIndex = truncated.lastIndexOf(' ');
    const minLastSpacePosition = Math.floor(maxLength * wordBreakThreshold);

    // If the last space is close enough to the end, truncate by word boundary
    if (lastSpaceIndex > minLastSpacePosition) {
      return truncated.substring(0, lastSpaceIndex);
    }

    // Otherwise, truncate by character limit
    return truncated;
  }
}
